import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestEmpresasVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'empresasveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteEmpresasVeiculo({ payload }) {
  try {
    const { idempresaveiculo, params } = payload;

    yield call(api.delete, `empresasveiculos/${idempresaveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { empresasveiculo, params } = payload;

    yield call(api.post, 'empresasveiculos', empresasveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/empresasveiculos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idempresaveiculo } = payload;

    const { data } = yield call(
      api.get,
      `empresasveiculos/${idempresaveiculo}`
    );
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { empresasveiculo, params } = payload;

    yield call(api.put, 'empresasveiculos', empresasveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/empresasveiculos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'empresasveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@empresasveiculo/EMPRESASVEICULOS_IN_REQUEST',
    requestEmpresasVeiculos
  ),
  takeLatest('@empresasveiculo/DELETE_EMPRESASVEICULO', deleteEmpresasVeiculo),
  takeLatest('@empresasveiculo/SUCCESS_REMOVE', requestEmpresasVeiculos),
  takeLatest('@empresasveiculo/STORE_EMPRESASVEICULO', store),
  takeLatest('@empresasveiculo/FIND_EMPRESASVEICULO', find),
  takeLatest('@empresasveiculo/UPDATE_EMPRESASVEICULO', update),
  takeLatest('@empresasveiculo/RECORD_FILTERING', applyedFilters),
]);
